const {findOptionalArgument, findArguments} = require("../util/ParserHelpers");

const variants = ["target", "controller", "silhouette"];
const commands = ["orthobot", "turnbot", "obstacle"];

const botSpriteParser = function(ps) {
	const optArg = findOptionalArgument(ps);
	const reqArgs = findArguments(ps, 1);

	if (!reqArgs) {
		ps.pushError("botSprite requires a sprite name");
		return false;
	}

	const variant = optArg ? optArg.text : "";

	if (variant && !variants.includes(variant)) {
		ps.pushError(`botSprite variant must be one of ${variants.join(",")}`);
		return false;
	}

	const name = reqArgs[0].text;

	if (!name || !commands.includes(name)) {
		ps.pushError(`botSprite name must be one of ${commands.join(",")}`);
		return false;
	}

	const imageName = (variant ? `${variant}-` : "") + name;

	let scale = 1;

	if (variant && variant === "controller") {
		scale = 1.5;
	}

	return {
		type: "botImage",
		name: `sprite/${imageName}`,
		scale,
	};
};

module.exports = {
	parsers: {
		mathCommands: {
			botSprite: botSpriteParser,
		},
	},
};
